import Page1 from "./pages/page1.jsx"
import './App.css';

function App() {
  return (
    <Page1/>
  );
}

export default App;
